<template>
  <div class="main">
    <report-top>
      <template slot="search">
        <ly-search v-model="searchItem.keyWork" @search="search"></ly-search>
      </template>
    </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" :addDay="-86400000" timeModel="2,3,0"></start-end>
      </div>

      <div class="formTableItem">
        <p class="label">项目名称</p>
        <div style="width: 120px">
          <selectItems
            :name="searchItem.groupName"
            @update:name="searchItem.groupName = $event"
            :id="searchItem.groupId"
            @update:id="searchItem.groupId = $event"
            clearable
          ></selectItems>
        </div>
      </div>

      <div class="formTableItem">
        <p class="label">所属部门</p>
        <selectGroup
          :name="searchItem.deptName"
          @update:name="searchItem.deptName = $event"
          :id="searchItem.deptId"
          @update:id="searchItem.deptId = $event"
          clearable
        >
        </selectGroup>
      </div>

      <div class="formTableItem">
        <Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },{
          title: "作业日期",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.jobDate, "yymmdd"));
          },
        },
        {
          title: "项目名称",
          key: "groupName",
        },
        {
          title: "应出勤人数",
          key: "attendanceNum",
        },
        {
          title: "不合格出勤人数",
          key: "noPassNum",
        },
        {
          title: "缺勤人数",
          key: "hookyNum",
        },
        {
          title: "迟到人数",
          key: "lateNum",
        },
        {
          title: "早退人数",
          key: "earlyNum",
        },
        {
          title: "出勤合格率/%",
          key: "passPercent",
        },

      ],
      tableData: [],
      total: 0,
      searchItem: {
        startDate: "",
        endDate: "",
        pageNumber: 0,
        pageSize: 0,
        groupId: "",
      },
    };
  },
  methods: {
    getList() {
      console.log(this.searchItem);
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.work + "/qualityAnalyse/personDisQualityAnaly",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(res);
        this.tableData = data;
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startDate = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endDate = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      console.log(this.keyWork);
      this.reset();
      this.getList();
    },
    reset() {},
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/work/personUnqualified.vue